/**
 * Default fair-usage credit limit assigned to a seat-based user when their
 * per-user limit isn't otherwise configured.
 *
 * Shared between the `UserSeatCreditLimit` column default, the Propel webhook
 * that seeds new users, and the admin pricing-model switch modal.
 */
export const DEFAULT_SEAT_CREDIT_LIMIT = 10000;
